import { ensureAuthenticated } from '@lune/auth/ensure'
import { Login } from '@lune/auth/login'
import { ErrorPage } from '@lune/common/errors'
import React from 'react'
import { Navigate, RouterProvider, createBrowserRouter } from 'react-router-dom'
import logo from '../assets/logo.png'
import './App.css'
import { version } from './api/version'
import { AliasMoveWrapper } from './components/aliasMove'
import { AliasNew } from './components/aliasNew'
import { Dashboard } from './components/dashboard'
import { Home } from './components/home'
import {
  AliasMove as AliasMoveUrl,
  AliasNew as AliasNewUrl,
  LoginApiUrl,
  LoginFailedPage,
  LoginPage,
  LoginSuccessPage,
  Root
} from './paths'

const DefaultPage = Root

const router = createBrowserRouter([
  {
    path: Root.root.url.toString(),
    element: <Dashboard />,
    loader: async () => await ensureAuthenticated(version, LoginPage, Root),
    errorElement: <ErrorPage />,
    children: [
      {
        path: Root.root.url.toString(),
        element: <Home />,
        errorElement: <ErrorPage />
      },
      {
        path: AliasNewUrl,
        element: <AliasNew />,
        errorElement: <ErrorPage />
      },
      {
        path: AliasMoveUrl,
        element: <AliasMoveWrapper />,
        errorElement: <ErrorPage />
      },
      {
        path: LoginSuccessPage.login.success.router.toString(),
        element: <Navigate to={DefaultPage.root.url} replace={true} />,
        errorElement: <ErrorPage />
      }
    ]
  },
  {
    path: LoginPage.login.url.toString(),
    element: (
      <Login
        name="Mail Manager"
        icon={<img src={logo} width={96} height={96} alt="app-logo" />}
        paths={{
          LoginApiUrl,
          LoginSuccessUrl: LoginSuccessPage,
          LoginFailedUrl: LoginFailedPage,
          RootUrl: Root
        }}
      />
    ),
    errorElement: <ErrorPage />
  }
])

export const App = (): React.JSX.Element => <RouterProvider router={router} />
